const styles = {
  dashboardNavContainer: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '200px',
    height: '100vh',
    background: '#fff',
    zIndex: 3000,
    transition: 'left 0.3s ease-in-out',
    '@media (max-width: 668px)': {
      left: '-200px',
    },
  },
  bottomNavWrapper: {
    top: 'initial',
    bottom: 0,
    height: 'auto',
    width: '100vw',
    textAlign: 'center' as const,
    zIndex: 100,
    display: 'flex',
    flexWrap: 'nowrap' as const,
  },
  bottomNav: {
    display: 'flex',
    a: {
      position: 'relative' as const,
      top: 0,
      left: 0,
      padding: 0,
      svg: {
        position: 'relative' as const,
        transform: 'translate(0, 0)',
        top: 0,
        left: 0,
      },
    },
  },
  rootNavWrapper: {
    zIndex: 200,
    '@media (min-width: 669px)': {
      display: 'none',
    },
  },
  dashboardWrapper: {
    position: 'absolute' as const,
    width: 'calc(100% - 200px)',
    left: '200px',
    height: '100vh',
    transition: 'left 0.3s ease-in-out',
    backgroundColor: '#fff',
    '@media (max-width: 668px)': {
      position: 'fixed' as const,
      top: 0,
      bottom: '65px',
      left: 0,
      right: 0,
      width: 'auto',
      height: 'auto',
      overflow: 'hidden',
      padding: '20px',
    },
  },
  dashboardContainer: (isAccountPage: boolean) => ({
    position: 'relative' as const,
    width: 'calc(100% - 35px)',
    height: 'calc(100vh - 100px)',
    background: '#f7f7f7',
    top: '80px',
    left: 0,
    borderRadius: '15px',
    border: '1px solid #eaeaea',
    overflowY: 'auto' as const,
    '@media (max-width: 1550px)': isAccountPage
      ? {
          top: '105px',
          height: 'calc(100vh - 125px)',
        }
      : {},
    '@media (max-width: 1270px)': isAccountPage
      ? {
          top: '130px',
          height: 'calc(100vh - 150px)',
        }
      : {},
    '@media (max-width: 668px)': {
      position: 'fixed' as const,
      width: 'calc(100% - 40px)',
      height: 'auto',
      top: '95px',
      bottom: '85px',
      left: '50%',
      transform: 'translateX(-50%)',
      overflowY: 'scroll' as const,
      '-webkit-overflow-scrolling': 'touch',
    },
  }),
}

export default styles
